import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { silentLogin, silentLoginExternal } from '../../core/state/auth/asyncActions';
import { AuthStatus } from '../../core/enums/AuthStatus';
import { msalInstance } from '../../core/constants/login/msalInstance';
import GlobalNotifications from '../../pages/components/global-notifications/GlobalNotifications';
import { LOGIN_ROUTE } from '../../core/constants/routes';
import { RootState } from '../../core/state/state';

const PageWrap: React.FC = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const status = useSelector((state: RootState) => state.auth.status);
  const isLoginRoute = location.pathname === LOGIN_ROUTE;

  const firstPageLoad = async () => {
    const account = msalInstance.getAllAccounts()[0];
    if (account) {
      await dispatch(silentLogin());
    } else {
      await dispatch(silentLoginExternal());
    }
  };

  React.useEffect(() => {
    firstPageLoad();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return status === AuthStatus.FirstLoad && !isLoginRoute ? null : (
    <>
      {children}
      <GlobalNotifications />
    </>
  );
};

export default PageWrap;
